// extracted by mini-css-extract-plugin
module.exports = {"icon":"AddItemButton_icon__fu_7W"};